import { useEffect } from 'react';

interface CommonObjectProps {
  hideBottomMenu: boolean;
}

const CommonObject: CommonObjectProps = {
  hideBottomMenu: false,
};

export const useMutationObserverMenu = (
  refMenu,
  refLinks,
  callbackMenu,
  callbackLinks,
  options = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true,
  },
) => {
  useEffect(() => {
    if (refMenu.current) {
      const observer = new MutationObserver(callbackMenu);
      observer.observe(refMenu.current, options);
      return () => observer.disconnect();
    }
  }, [callbackMenu, options, refMenu]);
  useEffect(() => {
    if (refLinks.current) {
      const observer = new MutationObserver(callbackLinks);
      observer.observe(refLinks.current, options);
      return () => observer.disconnect();
    }
  }, [callbackLinks, options, refLinks]);
};

export const checkSpaceMenuRubricFromBottom = (
  RubricMenu: React.RefObject<HTMLDivElement>,
  BottomMenu: React.RefObject<HTMLDivElement>,
  isPartnersNews: boolean,
  resize?: boolean,
) => {
  const { y: RubricMenuYPosition, height: RubricMenuHeight } = RubricMenu.current?.getBoundingClientRect();
  const { y: BottomMenuYPosition, height: BottomMenuHeight } = BottomMenu.current?.getBoundingClientRect();

  const RubricMenuSumYAndHeightPostion = isPartnersNews ? RubricMenuHeight : RubricMenuYPosition + RubricMenuHeight;
  const BottomMenuSumYAndHeightPostion = isPartnersNews
    ? BottomMenuYPosition - BottomMenuHeight - 24 * 3
    : resize
    ? BottomMenuYPosition
    : BottomMenuYPosition - BottomMenuHeight - 24;

  if (BottomMenuSumYAndHeightPostion < RubricMenuSumYAndHeightPostion) {
    CommonObject.hideBottomMenu = true;
    return false;
  } else {
    CommonObject.hideBottomMenu = false;
    return true;
  }
};

export const checkIconMenu = () => CommonObject.hideBottomMenu;
